import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Me, Media } from '@digilize/shared/definitions/src';
import { AuthService } from '@digilize/shared/feature/modules/auth/src/lib/auth.service';
import { appConfig } from '@suc/src/environments/app.config';

@Component({
  selector: 'suc-nav-bar',
  templateUrl: './nav-bar.component.html',
  styleUrls: ['./nav-bar.component.scss'],
})
export class NavBarComponent implements OnInit {
  @Input() me: Me;
  @Input() logo: Media;
  @Input() navigationElement: HTMLElement;
  @Input() navigationOpened: boolean;
  @Output() navOpenChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() navOpenClose: EventEmitter<boolean> = new EventEmitter<boolean>();
  userMenuOpen: boolean;
  appConfig = appConfig;
  constructor(private authService: AuthService) {}

  ngOnInit(): void {}

  logout() {
    this.authService.logout('/auth');
  }
}
